import { createReducer, on, Action } from "@ngrx/store";
import { IDevicesState } from "src/app/utils/interfaces/store.interfaces";
import { clearPermissionDataAction } from "../actions/app.actions";
import { getDevicesSuccessAction, getRestoreDevicesSuccessAction, getRestoreDevicesFailedAction, getDeviceProblemsSuccessAction, getDeviceLoggingSuccessAction, getDeviceLoggingFailedAction, getDeviceCompaniesSuccessAction, getRemoteConnectionsSuccessAction, getRemoteConnectionsFailedAction, getDeviceConnectionsFailedAction, getDeviceConnectionsSuccessAction, getStoreInfoSuccessAction, getStoreInfoFailedAction, getLocationAutocompleteFailedAction, getLocationDataByAddressFailedAction, getLocationAutocompleteSuccessAction, getLocationDataByAddressSuccessAction, getAuthInfoDevicesSuccessAction, getAuthInfoDevicesFailedAction, setDeviceCompaniesSuccessAction, setStoreInfoSuccessAction, getUpgradeStatusFailedAction, getMenderReleasesFailedAction, getMenderReleasesSuccessAction, getUpgradeStatusSuccessAction, getUpgradeDevicesSuccessAction, getUpgradeDevicesFailedAction, getDeviceFirmwareSuccessAction, getDeviceFirmwareFailedAction, uploadDeviceFirmwareSuccessAction, deleteDeviceFirmwareSuccessAction, setFirmwareMetadataSuccessAction, getDeviceTelemetryFailedAction, getDeviceTelemetrySuccessAction, getXpacDevicesSuccessAction, getXpacDevicesFailedAction, getMapDevicesSuccessAction, getMapDevicesFailedAction } from "../actions/devices.actions";
import { hasValue } from 'src/app/angular-core/utils/functions/common.functions';

const initialState: IDevicesState = {
  devices: null,
  mapDevices: null,
  upgradeDevices: null,
  devicesQuery: null,
  currentDeviceProblems: null,
  remoteConnections: null,
  permission: null,
  currentDeviceConnections: null,
  xpacCompanyInfo: null,
  detailedXpacInfo: null,
  restoreDevicesXpac: null,
  crossNetDevices: null,
  telemetry: null,
  getLocationAutocompleteData: null,
  currentAutocompleteAddress: null,
  deviceLogging: null,
  deviceFirmware: null,
  firmwareReleases: null,
  deploymentStatus: null
}

export const devicesReducerImplicit = createReducer(
  initialState,
  on(getDevicesSuccessAction, (state, {data: { query, devices }}) => ({
    ...state,
    devicesQuery: query,
    devices: devices,
  })),
  on(getMapDevicesSuccessAction, (state, { data: mapDevices }) => ({
    ...state,
    mapDevices: mapDevices,
  })),
    on(getMapDevicesFailedAction, (state) => ({
    ...state,
    mapDevices: null,
  })),
  on(getUpgradeDevicesSuccessAction, (state, {data: upgradeDevices}) => ({
    ...state,
    upgradeDevices: upgradeDevices,
  })), 
  on(getUpgradeDevicesFailedAction, (state) => ({
    ...state,
    upgradeDevices: null,
  })), 
  on(getRestoreDevicesSuccessAction, (state, {data: restoreDevicesXpac}) => ({
    ...state,
    restoreDevicesXpac,
  })),
  on(getRestoreDevicesFailedAction, (state) => ({
    ...state,
    restoreDevicesXpac: null,
  })),
  on(getDeviceProblemsSuccessAction, (state, {data: currentDeviceProblems}) => ({
    ...state,
    currentDeviceProblems,
  })),
  on(getDeviceLoggingSuccessAction, (state, { data }) => ({
    ...state,
    deviceLogging: {
      deviceId: data.deviceId,
      messages: data.append
        ? [
            ...(state.deviceLogging?.deviceId === data.deviceId
              ? state.deviceLogging.messages
              : []),
            ...data.page.messages
          ]
        : data.page.messages,
      continuationToken: data.page.continuationToken
    }
  })),
  on(getDeviceLoggingFailedAction, (state) => ({
    ...state,
    deviceLogging: null,
  })),
  on(getXpacDevicesSuccessAction, (state, { data: xpacDevices }) => ({
    ...state,
    crossNetDevices: xpacDevices,
  })),
  on(getXpacDevicesFailedAction, (state) => ({
    ...state,
    crossNetDevices: null,
  })),
  on(getDeviceCompaniesSuccessAction, (state, {data: xpacCompanyInfo}) => ({
    ...state,
    xpacCompanyInfo,
  })),
  on(setDeviceCompaniesSuccessAction, (state, {data: xpacCompanyInfo}) => ({
    ...state,
    xpacCompanyInfo,
  })),
  on(getDeviceCompaniesSuccessAction, (state, {data: xpacCompanyInfo}) => ({
    ...state,
    xpacCompanyInfo,
  })),
  on(getRemoteConnectionsSuccessAction, (state, {data: remoteConnections}) => ({
    ...state,
    remoteConnections: remoteConnections,
  })),
  on(getRemoteConnectionsFailedAction, (state) => ({
    ...state,
    remoteConnections: null,
  })),
  on(getDeviceConnectionsFailedAction, (state) => ({
    ...state,
    xpacCompanyInfo: null,
  })),
  on(getDeviceConnectionsSuccessAction, (state, {data: currentDeviceConnections}) => ({
    ...state,
    currentDeviceConnections,
  })),
  on(getDeviceTelemetryFailedAction, (state, { data: deviceId }) => ({
    ...state,
    telemetry: state.telemetry?.deviceId === deviceId ? null : state.telemetry,
  })),
  on(getDeviceTelemetrySuccessAction, (state, { data: telemetry }) => ({
    ...state,
    telemetry,
  })),
  on(getStoreInfoSuccessAction, (state, {data: detailedXpacInfo}) => ({
    ...state,
    detailedXpacInfo,
  })),
  on(getStoreInfoFailedAction, (state) => ({
    ...state,
    detailedXpacInfo: null,
  })),
  on(getLocationAutocompleteFailedAction, (state) => ({
    ...state,
    getLocationAutocompleteData: null
  })),
  on(getLocationDataByAddressFailedAction, (state) => ({
    ...state,
    currentAutocompleteAddress: null,
  })),
  on(getLocationAutocompleteSuccessAction, (state, { data: getLocationAutocompleteData }) => ({
    ...state,
    getLocationAutocompleteData,
  })),
  on(getLocationDataByAddressSuccessAction, (state, { data: currentAutocompleteAddress }) => ({
    ...state,
    currentAutocompleteAddress,
  })),
  on(getAuthInfoDevicesSuccessAction, (state, {data: permission}) => ({
    ...state,
    permission,
  })),
  on(getAuthInfoDevicesFailedAction, (state,) => ({
    ...state,
    permission: null,
  })),
  on(clearPermissionDataAction, (state) => ({
    ...state,
    permission: null,
  })),
  on(getDeviceFirmwareFailedAction, (state) => ({
    ...state,
    deviceFirmware: null,
  })),
  on(getDeviceFirmwareSuccessAction, (state, { data }) => ({
    ...state,
    deviceFirmware: data,
  })),
  on(uploadDeviceFirmwareSuccessAction, (state, { data }) => ({
    ...state,
    deviceFirmware: [...(state.deviceFirmware ?? []), data],
  })),
  on(deleteDeviceFirmwareSuccessAction, (state, { data }) => ({
    ...state,
    deviceFirmware: (state.deviceFirmware ?? []).filter(f => f.id !== data),
  })),
  on(setFirmwareMetadataSuccessAction, (state, { data }) => ({
    ...state,
    deviceFirmware: (state.deviceFirmware ?? []).map(f => f.id !== data.id ? f : { ...f, ...data }),
  })),
  on(setStoreInfoSuccessAction, (state, { data: { deviceId, patchStoreInfo } }) => {
    if (!state.devices) {
      return state;
    }
    
    const xpacIndex = state.devices.findIndex(x => x.deviceId === deviceId);
    if (xpacIndex < 0) {
      return state;
    }

    // Note: Don't cast this to a BasicXpacInfo because then we can't update the properties
    const xpac = { ...state.devices[xpacIndex] };
    
    // Name
    if (hasValue(patchStoreInfo.storeName)) {
      xpac.storeName = patchStoreInfo.storeName;
    }
    // Codes
    xpac.storeCodes = {
      storeId: hasValue(patchStoreInfo.storeId) ? patchStoreInfo.storeId : xpac.storeCodes.storeId,
      customId: hasValue(patchStoreInfo.customId) ? patchStoreInfo.customId : xpac.storeCodes.customId,
      groupId: hasValue(patchStoreInfo.groupId) ? patchStoreInfo.groupId : xpac.storeCodes.groupId,
      regionId: hasValue(patchStoreInfo.regionId) ? patchStoreInfo.regionId : xpac.storeCodes.regionId,
      retailerId: hasValue(patchStoreInfo.retailerId) ? patchStoreInfo.retailerId : xpac.storeCodes.retailerId,
    };
    // Address
    if (hasValue(patchStoreInfo.address)) {
      xpac.storeAddress = patchStoreInfo.address;
    }
    
    const lastInstalledDevices = [...state.devices];
    lastInstalledDevices[xpacIndex] = xpac;

    return {
      ...state,
      devices: lastInstalledDevices,
    }
  }),
  on(getMenderReleasesSuccessAction, (state, { data: firmwareArtifacts }) => ({
    ...state,
    firmwareReleases: firmwareArtifacts,
  })),
  on(getUpgradeStatusSuccessAction, (state, { data: firmwareUpdateStatus }) => ({
    ...state,
    // We could merge these two to avoid deleting data from devices that we did not include in this request
    // but there is no usecase for that at the moment, so just replace the store value entirely.
    deploymentStatus: firmwareUpdateStatus,
  })),
  on(getMenderReleasesFailedAction, (state,) => ({
    ...state,
    firmwareReleases: null,
  })),
  on(getUpgradeStatusFailedAction, (state, { data: deviceIds }) => ({
    ...state,
    deploymentStatus: state.deploymentStatus?.filter(d => !deviceIds.includes(d.deviceId)),
  })),
);

export function devicesReducer(state: any, action: Action): IDevicesState {
  return devicesReducerImplicit(state, action);
}
